<template>
    <!-- 绩效分析 不用后期可删掉-->
    <div class="pool_record">
      <el-row class="row-two">
        <h3 class="title">收益率</h3>
      </el-row>
      <el-table :data="sylTab" class="table-two mt15" border>
        <el-table-column label="分类" prop="name"></el-table-column>
        <el-table-column :label="String(time[0])"  prop="yield[0]"></el-table-column>
        <el-table-column :label="String(time[1])"  prop="yield[1]"></el-table-column>
        <el-table-column :label="String(time[2])"  prop="yield[2]"></el-table-column>
        <el-table-column :label="String(time[3])"  prop="yield[3]"></el-table-column>
        <el-table-column :label="String(time[4])"  prop="yield[4]"></el-table-column>
        <el-table-column :label="String(time[5])"  prop="yield[5]"></el-table-column>
        <el-table-column :label="String(time[6])"  prop="yield[6]"></el-table-column>
        <el-table-column :label="String(time[7])"  prop="yield[7]"></el-table-column>
        <el-table-column :label="String(time[8])"  prop="yield[8]"></el-table-column>
        <el-table-column :label="String(time[9])"  prop="yield[9]"></el-table-column>
      </el-table>
      <el-row class="row-two mt30">
        <h3 class="title">最大回撤</h3>
      </el-row>
      <el-table :data="totalTab[0]" class="table-two mt15" border>
        <el-table-column label="分类" prop="name"></el-table-column>
        <el-table-column :label="String(year[0])"  prop="yield[0]"></el-table-column>
        <el-table-column :label="String(year[1])"  prop="yield[1]"></el-table-column>
        <el-table-column :label="String(year[2])"  prop="yield[2]"></el-table-column>
        <el-table-column :label="String(year[3])"  prop="yield[3]"></el-table-column>
        <el-table-column :label="String(year[4])"  prop="yield[4]"></el-table-column>
        <el-table-column :label="String(time[5])"  prop="yield[5]"></el-table-column>
        <el-table-column :label="String(time[6])"  prop="yield[6]"></el-table-column>
        <el-table-column :label="String(time[7])"  prop="yield[7]"></el-table-column>
        <el-table-column :label="String(time[8])"  prop="yield[8]"></el-table-column>
        <el-table-column :label="String(time[9])"  prop="yield[9]"></el-table-column>
      </el-table>
      <el-row class="row-two mt30">
        <h3 class="title">波动率</h3>
      </el-row>
      <el-table :data="totalTab[1]" class="table-two mt15" border>
        <el-table-column label="分类" prop="name"></el-table-column>
        <el-table-column :label="String(year[0])"  prop="yield[0]"></el-table-column>
        <el-table-column :label="String(year[1])"  prop="yield[1]"></el-table-column>
        <el-table-column :label="String(year[2])"  prop="yield[2]"></el-table-column>
        <el-table-column :label="String(year[3])"  prop="yield[3]"></el-table-column>
        <el-table-column :label="String(year[4])"  prop="yield[4]"></el-table-column>
        <el-table-column :label="String(time[5])"  prop="yield[5]"></el-table-column>
        <el-table-column :label="String(time[6])"  prop="yield[6]"></el-table-column>
        <el-table-column :label="String(time[7])"  prop="yield[7]"></el-table-column>
        <el-table-column :label="String(time[8])"  prop="yield[8]"></el-table-column>
        <el-table-column :label="String(time[9])"  prop="yield[9]"></el-table-column>
      </el-table>
      <el-row class="row-two mt30">
        <h3 class="title">夏普比率</h3>
      </el-row>
      <el-table :data="totalTab[3]" class="table-two mt15" border>
        <el-table-column label="分类" prop="name"></el-table-column>
        <el-table-column :label="String(year[0])"  prop="yield[0]"></el-table-column>
        <el-table-column :label="String(year[1])"  prop="yield[1]"></el-table-column>
        <el-table-column :label="String(year[2])"  prop="yield[2]"></el-table-column>
        <el-table-column :label="String(year[3])"  prop="yield[3]"></el-table-column>
        <el-table-column :label="String(year[4])"  prop="yield[4]"></el-table-column>
        <el-table-column :label="String(time[5])"  prop="yield[5]"></el-table-column>
        <el-table-column :label="String(time[6])"  prop="yield[6]"></el-table-column>
        <el-table-column :label="String(time[7])"  prop="yield[7]"></el-table-column>
        <el-table-column :label="String(time[8])"  prop="yield[8]"></el-table-column>
        <el-table-column :label="String(time[9])"  prop="yield[9]"></el-table-column>
      </el-table>
    </div>
</template>

<script>
export default {
  name: "performanceAnalysis",
  data () {
    return {
      // 绩效分析
      totalTab:[[],[],[],[],[],[]],//最大回撤 波动率 下行标准差 夏普比率 索提诺比率 卡玛比率
      year: [],
      sylTab: [],
      time: [],
    }
  },
  mounted () {
    this.getTable()
    this.getStrategyYieldHistory ()
  },
  methods: {
    getTable () {
      const vm = this;
      vm.$http.post(vm.$apiPath.GetStrategySeniorIndex, {}).then(res => {
        // console.log(res);
        let tabData = res.data.data.strategyIndexList
        let tabName = res.data.data.strategyNameList
        vm.year = res.data.data.yieldYearList
        for(let i = 0; i < 4; i++) {
          for (var j = 0; j < tabName.length; j++) {
            vm.totalTab[i].push({ name: tabName[j], yield: tabData[j][i]})
          }
        }
      }).catch(err => { })
    },
    // 收益率
    getStrategyYieldHistory () {
      let vm = this
      vm.$http.post(vm.$apiPath.GetStrategyYieldHistory, {}).then(res => {
        // console.log(res);
        let tabName = res.data.data.strategyNameList
        let tabData = res.data.data.strategyYieldList
        vm.time = res.data.data.yieldYearList
        for(let i = 0; i < tabName.length; i++) {
          for(let j = 0; j < 10; j++) {
            tabData[i][j] = parseFloat(tabData[i][j]*100).toFixed(2) + '%'
          }
          vm.sylTab.push({ name: tabName[i], yield: tabData[i]})
        }
      }).catch(err => { })
    },
  }
}
</script>

<style lang="less" scoped>
</style>